import { getClientsAndClientsAccountsConfig } from '../../../shared/api/AccountsApi';
import { LOAD_STATE } from '../../../shared/axios';

const GET_COMPANY_AND_ACCOUNTS_REQUEST_CALLED = 'GET_COMPANY_AND_ACCOUNTS_REQUEST_CALLED';
const GET_COMPANY_AND_ACCOUNTS_REQUEST_SUCCEEDED = 'GET_COMPANY_AND_ACCOUNTS_REQUEST_SUCCEEDED';
const GET_COMPANY_AND_ACCOUNTS_REQUEST_FAILED = 'GET_COMPANY_AND_ACCOUNTS_REQUEST_FAILED';

export const getCompaniesAndCompaniesAccountsState = state => state
    .company.companiesAndCompaniesAccounts;

export const getCompaniesAndCompaniesAccounts = (
    search = '',
) => ({
    type: GET_COMPANY_AND_ACCOUNTS_REQUEST_CALLED,
    actionTypes: {
        success: GET_COMPANY_AND_ACCOUNTS_REQUEST_SUCCEEDED,
        fail: GET_COMPANY_AND_ACCOUNTS_REQUEST_FAILED,
    },
    config: getClientsAndClientsAccountsConfig({
        search,
    }),
});

const initialState = {
    loadState: LOAD_STATE.LOADING,
    data: [],
    error: null,
};

export const companiesAndCompaniesAccountsReducer = (state = initialState, action) => {
    switch (action.type) {
    case GET_COMPANY_AND_ACCOUNTS_REQUEST_CALLED:
        return {
            ...state,
            loadState: LOAD_STATE.LOADING,
            data: [],
            error: null,

        };
    case GET_COMPANY_AND_ACCOUNTS_REQUEST_SUCCEEDED:
        return {
            ...state,
            loadState: LOAD_STATE.SUCCESS,
            data: action.payload.data.results,
            error: null,

        };
    case GET_COMPANY_AND_ACCOUNTS_REQUEST_FAILED:
        return {
            ...state,
            loadState: LOAD_STATE.FAIL,
            data: [],
            error: action.payload,

        };
    default:
        return state;
    }
};
